import React, { useEffect } from "react";
import "./App.css";

import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ServicePage from "./components/pages/ServicePage";
import ProjectPage from './components/pages/ProjectPage';
import SolarCalculator from './components/Landingpages/SolarCalculator';
import About from './components/Landingpages/About';
import Contact from './components/Landingpages/Contact';

import WhatsAppFloat from './components/common/WhatsAppFloat';

import Dashboard from "./components/Admin/Dashboard";
import Leads from "./components/Admin/Leads";
import LeadDetail from "./components/Admin/LeadDetail";
import Quotation from "./components/Admin/Quotation";
import Projects from "./components/Admin/Projects";
import ProjectForm from "./components/Admin/ProjectForm";
import Employees from "./components/Admin/Employees";

import EmpDashboard from "./components/Employee/Dashboard";
import MyLeads from "./components/Employee/MyLeads";
import UpdateStatus from "./components/Employee/UpdateStatus";
import DailyReport from "./components/Employee/DailyReport";
import Login from "./components/auth/Login";
import { useAuth } from "./components/auth/AuthContext";
import ScrollToTop from "./components/common/ScrollToTop";
import { Routes, Route, Navigate } from "react-router-dom";
import Enquiries from "./components/Admin/Enquiries"
import Testimonials from "./components/Admin/Testimonials";

const ProtectedRoute = ({ children, allowedRole }) => {
  const { isAuthenticated, userRole, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-white">
        <div className="w-8 h-8 border-4 border-[#10B981] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const currentRole = userRole?.toLowerCase();
  const targetRole = allowedRole?.toLowerCase();

  const hasAccess = 
    currentRole === targetRole || 
    (targetRole === 'employee' && currentRole === 'staff'); 

  if (allowedRole && !hasAccess) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const WebsiteLayout = ({ children }) => {
  useEffect(() => {
    document.documentElement.classList.remove('dark');
  }, []);

  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

function App() {
  return (
    <>
      {/* 🚀 Global Scroll-To-Top on every route change */}
      <ScrollToTop />

      <Routes>
        {/* 🏠 Customer Website */}
        <Route path="/" element={<WebsiteLayout><Home /></WebsiteLayout>} />
        <Route path="/servicespage" element={<WebsiteLayout><ServicePage /></WebsiteLayout>} />
        <Route path="/projectpage" element={<WebsiteLayout><ProjectPage /></WebsiteLayout>} />
        <Route path="/calculator" element={<WebsiteLayout><SolarCalculator /></WebsiteLayout>} />
        <Route path="/contact" element={<WebsiteLayout><Contact /></WebsiteLayout>} />
        <Route path="/about" element={<WebsiteLayout><About /></WebsiteLayout>} />

        {/* 🔐 Login (NO Navbar/Footer) */}
        <Route path="/login" element={<Login />} />

        {/* 👨‍💼 Admin Routes */}
        <Route path="/admin" element={<ProtectedRoute allowedRole="admin"><Dashboard /></ProtectedRoute>} />
        <Route path="/admin/leads" element={<ProtectedRoute allowedRole="admin"><Leads /></ProtectedRoute>} />
        <Route path="/admin/leads/:id" element={<ProtectedRoute allowedRole="admin"><LeadDetail /></ProtectedRoute>} />
        <Route path="/admin/quotations" element={<ProtectedRoute allowedRole="admin"><Quotation /></ProtectedRoute>} />
        <Route path="/admin/projects" element={<ProtectedRoute allowedRole="admin"><Projects /></ProtectedRoute>} />
        <Route path="/admin/projects/add" element={<ProtectedRoute allowedRole="admin"><ProjectForm /></ProtectedRoute>} />
        <Route path="/admin/projects/edit/:id" element={<ProtectedRoute allowedRole="admin"><ProjectForm /></ProtectedRoute>} />
        <Route path="/admin/employees" element={<ProtectedRoute allowedRole="admin"><Employees /></ProtectedRoute>} />
        <Route path="/admin/enquiries"element={<ProtectedRoute allowedRole="admin"><Enquiries /></ProtectedRoute>}/>
        <Route path="/admin/testimonials" element={<ProtectedRoute allowedRole="admin"><Testimonials /></ProtectedRoute>} />

        {/* 🧑‍💼 Employee Routes */}
        <Route path="/employee" element={<ProtectedRoute allowedRole="employee"><EmpDashboard /></ProtectedRoute>} />
        <Route path="/employee/leads" element={<ProtectedRoute allowedRole="employee"><MyLeads /></ProtectedRoute>} />
        <Route path="/employee/update-status" element={<ProtectedRoute allowedRole="employee"><UpdateStatus /></ProtectedRoute>} />
        <Route path="/employee/daily-report" element={<ProtectedRoute allowedRole="employee"><DailyReport /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

export default App;